import React, { useCallback, useEffect, useState } from 'react';
import App from '../App';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getAuthConfig } from '../api/resource';
import ErrorPage from './ErrorPageComponent/ErrorPage.component';
import { getAuthConfigFromStorage, saveAuthConfig } from '../utils/authStorage';

const StartupComponent = () => {
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');

  const init = useCallback(async () => {
    setStatus('loading');
    const cachedConfig = getAuthConfigFromStorage();

    if (cachedConfig) {
      setStatus('ready');
      return;
    }

    try {
      const config = await getAuthConfig();
      saveAuthConfig(config.data);
      setStatus('ready');
    } catch (e) {
      setStatus('error');
    }
  }, []);

  useEffect(() => {
    init();
  }, []);

  if (status === 'loading') {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress size={48} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Загрузка конфигурации...
        </Typography>
      </Box>
    );
  }

  if (status === 'error') {
    return <ErrorPage onRetry={init} />;
  }

  return <App />;
};

export default StartupComponent;